function initFileAttachments() {
  document
    .querySelectorAll(".file-attachment[data-upload-url]")
    .forEach((container) => {
      initFileAttachment(container)
    })
}

function initFileAttachment(container) {
  const form = container.closest("form")
  const uploadUrl = container.dataset.uploadUrl
  const multiple = container.dataset.multiple === "true"
  const inputName = container.dataset.inputName
  const valueKey = container.dataset.valueKey || "id"
  const deleteLabel = container.dataset.deleteLabel || "delete"
  const fileIcon = container.dataset.fileIcon || ""
  const addLabel = container.dataset.addLabel
  const addMoreLabel = container.dataset.addMoreLabel || addLabel
  const errorLabel = container.dataset.errorLabel || "Upload failed"
  const fileInput = container.querySelector(".file-attachment__input")
  const addLink = container.querySelector('[data-type="add"]')
  const fileList = container.querySelector(".file-attachment__list")
  const submitButton = form?.querySelector('button[type="submit"]')
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

  if (!fileInput || !addLink || !fileList) {
    return
  }

  function updateAddLinkLabel() {
    if (!addMoreLabel || !addLabel) {
      return
    }

    const hasFiles =
      fileList.querySelectorAll(".file-attachment__file-info").length > 0
    const textNode = addLink.lastChild

    if (textNode && textNode.nodeType === Node.TEXT_NODE) {
      textNode.textContent = hasFiles ? addMoreLabel : addLabel
    }
  }

  function clearError() {
    container.querySelectorAll(".file-attachment__error").forEach((el) => {
      el.remove()
    })
    container.closest(".FormElement")?.classList.remove("FormElement--error")
  }

  function showError(message, file) {
    let list = container.querySelector(".file-attachment__error")

    if (!list) {
      list = document.createElement("span")
      list.className = "FormElement__error file-attachment__error"
      addLink.insertAdjacentElement("afterend", list)
    }

    const line = document.createElement("span")
    line.textContent = multiple ? `${file.name}: ${message}` : message
    list.appendChild(line)

    container.closest(".FormElement")?.classList.add("FormElement--error")
  }

  // Restore existing items (server-rendered or after validation error)
  fileList.querySelectorAll(".file-attachment__file-info").forEach((item) => {
    bindDeleteHandler(item)
  })

  addLink.addEventListener("click", (e) => {
    e.preventDefault()
    fileInput.click()
  })

  fileInput.addEventListener("change", () => {
    if (!fileInput.files || fileInput.files.length === 0) {
      return
    }

    clearError()
    Array.from(fileInput.files).forEach((file) => {
      uploadFile(file)
    })
    fileInput.value = ""
  })

  function uploadFile(file) {
    if (!multiple) {
      fileList
        .querySelectorAll(".file-attachment__file-info")
        .forEach((item) => {
          item.remove()
        })
    }

    const item = document.createElement("div")
    item.className = "file-attachment__file-info"
    item.style.display = "flex"
    item.innerHTML = `
      ${fileIcon}
      <span class="file-attachment__filename">${escapeHtml(file.name)}</span>
      <span class="file-attachment__loader" style="display: inline-block;"><span class="loading loading--small"></span></span>
      <a class="file-attachment__link" data-type="delete" style="visibility: hidden;" href="#">${escapeHtml(deleteLabel)}</a>`
    fileList.appendChild(item)
    updateAddLinkLabel()

    if (!multiple) {
      addLink.style.display = "none"
    }

    if (submitButton) {
      submitButton.disabled = true
    }

    const formData = new FormData()
    formData.append("file", file)

    fetch(uploadUrl, {
      method: "POST",
      body: formData,
      headers: { "X-CSRF-Token": csrfToken },
    })
      .then((response) => {
        if (response.ok) {
          return response.json()
        }

        // The server reports why (wrong type, too large) — show that.
        return response
          .json()
          .catch(() => ({}))
          .then((data) => {
            throw new Error((data.errors || []).join(" ") || errorLabel)
          })
      })
      .then((data) => {
        const hiddenInput = document.createElement("input")
        hiddenInput.type = "hidden"
        hiddenInput.name = inputName
        hiddenInput.value = data[valueKey]
        if (data.delete_path) {
          hiddenInput.dataset.deletePath = data.delete_path
        }
        item.appendChild(hiddenInput)

        item.querySelector(".file-attachment__loader").style.display = "none"
        bindDeleteHandler(item)
        item.querySelector('[data-type="delete"]').style.visibility = "visible"
        if (submitButton) {
          submitButton.disabled = false
        }
        updateAddLinkLabel()
      })
      .catch((error) => {
        item.remove()
        if (!multiple) {
          addLink.style.display = ""
        }
        if (submitButton) {
          submitButton.disabled = false
        }
        updateAddLinkLabel()
        showError(error.message || errorLabel, file)
      })
  }

  function bindDeleteHandler(item) {
    const deleteLink = item.querySelector('[data-type="delete"]')
    if (!deleteLink) {
      return
    }

    deleteLink.addEventListener("click", (e) => {
      e.preventDefault()
      const input = item.querySelector('input[type="hidden"]')

      if (input?.dataset.deletePath) {
        fetch(input.dataset.deletePath, {
          method: "DELETE",
          headers: { "X-CSRF-Token": csrfToken, Accept: "application/json" },
        })
      }

      item.remove()
      clearError()
      if (!multiple) {
        addLink.style.display = ""
      }
      updateAddLinkLabel()
    })
  }
}

function escapeHtml(text) {
  const div = document.createElement("div")
  div.textContent = text
  return div.innerHTML
}

window.initFileAttachments = initFileAttachments

document.addEventListener("DOMContentLoaded", initFileAttachments)
